var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * h5 生小孩裁图页
 */
import React, { useCallback, useRef, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './index.module.scss';
import CropPage from '../../lib/components/Pages/CropPage';
import { setFatherCropImg, setFatherOriginImg, setMotherCropImg, setMotherOriginImg, } from '../../lib/common/store/reducer/h5-baby';
import { updateCurPageAction, updateFaceLocationInfo, } from '../../lib/common/store/reducer/actions';
import { getFaceNumber } from '../../lib/utils/fetch-data';
import { ERROR_CODE_MAPPING } from '../H5ChristmasIndexPage/h5-config';
import { computeFaceInfo } from '../../lib/utils/face-detect';
import Modal from '../../lib/components/Modal';
const H5BabyCropPage = ({ data: { maskImageUrl, backgroundUrl, submitBtnImgUrl, changePicUrl, cropTipUrl, logoUrl, loadingUrl, faceAreaRatio = 0.3, }, }) => {
    const dispatch = useDispatch();
    const cropRef = useRef(null);
    const currentCropType = useSelector(store => store.h5Baby.currentCropType);
    const faceLocationInfo = useSelector(store => store.base.faceInfo);
    const userOriginImage = useSelector(store => {
        const currentType = store.h5Baby.currentCropType;
        if (currentType === 'mother') {
            return store.h5Baby.motherOriginImg;
        }
        return store.h5Baby.fatherOriginImg;
    });
    const [isShowLoading, setLoadingStatus] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState('');
    const [isErrorModalShow, setErrorModalStatus] = useState(false);
    const handleCropImage = useCallback((imgData) => __awaiter(void 0, void 0, void 0, function* () {
        if (currentCropType === 'father') {
            dispatch(setFatherCropImg(imgData));
        }
        if (currentCropType === 'mother') {
            dispatch(setMotherCropImg(imgData));
        }
        dispatch(updateCurPageAction('choose_image'));
    }), [currentCropType, dispatch]);
    const loadingContent = () => (React.createElement("div", { className: style['loading-container'] },
        React.createElement("img", { src: loadingUrl, alt: "" })));
    const handleChangePic = useCallback((img) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // 人脸识别
        setLoadingStatus(true);
        const res = yield getFaceNumber(img.split(',')[1].trim());
        const code = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code;
        if (code !== 0) {
            setLoadingStatus(false);
            const errMsg = ERROR_CODE_MAPPING[code]
                ? ERROR_CODE_MAPPING[code].msg
                : '活动太火爆了，请稍后再试';
            setFeedbackMsg(errMsg);
            setErrorModalStatus(true);
            return;
        }
        const { data } = res;
        const extraInfo = JSON.parse(data.extra);
        const faceInfo = yield computeFaceInfo(extraInfo, img, faceAreaRatio);
        if (currentCropType === 'father') {
            dispatch(setFatherOriginImg(img));
        }
        else {
            dispatch(setMotherOriginImg(img));
        }
        dispatch(updateFaceLocationInfo(faceInfo));
        setLoadingStatus(false);
    }), [currentCropType, isShowLoading, isErrorModalShow, feedbackMsg]);
    const getLoadingContent = useMemo(() => (React.createElement("div", { className: style['loading-modal'] },
        React.createElement("img", { src: loadingUrl, alt: "" }))), [isShowLoading]);
    const getErrorModalContent = useMemo(() => (React.createElement("div", { className: style['feedback-modal'] },
        React.createElement("div", { className: style['feedback-modal-title'] }, feedbackMsg),
        React.createElement("div", { className: style['feedback-modal-action-btn'], onClick: () => {
                setErrorModalStatus(false);
            } }, "\u597D\u7684"))), [isErrorModalShow]);
    return (React.createElement("div", { className: style['crop-page'], style: { backgroundImage: `url(${backgroundUrl})` } },
        React.createElement(CropPage, { maskImgUrl: maskImageUrl, originImage: userOriginImage, submitBtnImgUrl: submitBtnImgUrl, changePictureImgUrl: changePicUrl, handleBackendLogic: handleCropImage, styleCustom: style, isOriginPickerInWechat: true, ratio: 1, logoUrl: logoUrl, ref: cropRef, customLoadingContent: loadingContent(), autoCropLocation: faceLocationInfo, handelReselectAction: handleChangePic },
            React.createElement("div", { className: style['cut-tip'] },
                React.createElement("img", { src: cropTipUrl, alt: "alt" }))),
        React.createElement(Modal, { content: getLoadingContent, visible: isShowLoading, hideModal: () => setLoadingStatus(false) }),
        React.createElement(Modal, { content: getErrorModalContent, visible: isErrorModalShow, hideModal: () => {
                setErrorModalStatus(false);
            } })));
};
export default H5BabyCropPage;
